'use client'

import { useAttributionTracking } from '@/hooks/useAttributionTracking'

/**
 * Client component that captures attribution parameters for store pages
 * Renders nothing, just handles side effects for tracking
 */
export default function StoreAttributionTracker() {
    useAttributionTracking()
    return null
}

